import { Mic, MicOff } from "lucide-react";
import { toast } from "sonner";
import { useDictee } from "./useDictee";

export const DicteeBouton = ({ onTexte, testId, label = "Dicter dans ce champ" }) => {
  const { actif, demarrer, arreter } = useDictee(onTexte);
  const basculer = () => {
    if (actif) return arreter();
    if (!demarrer()) toast.error("La dictée n'est pas disponible sur ce navigateur : saisissez le texte au clavier.");
  };
  return (
    <button type="button" onClick={basculer} aria-label={label} data-testid={testId}
      className="shrink-0 w-11 h-11 at-pill flex items-center justify-center transition-transform duration-150 active:scale-95"
      style={{ background: actif ? "var(--temp-3)" : "color-mix(in srgb, var(--temp-3) 18%, transparent)", color: actif ? "var(--accent-ink)" : "var(--temp-3)" }}>
      {actif ? <MicOff size={17} /> : <Mic size={17} />}
    </button>
  );
};

export const ajouterTexte = (actuel, ajout) => [String(actuel ?? "").trim(), ajout].filter(Boolean).join(" ");
